import React from 'react';
import { SectionHeading } from './BrandMark';

export function WhySection({ copy }) {
  const section = copy.why;
  return (
    <section id="why" className="relative scroll-mt-16 overflow-hidden bg-[#0A0A0A] py-24 lg:py-32" aria-labelledby="why-title">
      <img
        src="/brand/seal.webp"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 top-10 hidden w-[36rem] opacity-[0.07] lg:block"
        loading="lazy"
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading eyebrow={section.eyebrow} title={section.title} tone="light" />
        <h2 id="why-title" className="sr-only">{section.title}</h2>

        <div className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {section.pillars.map((pillar, index) => (
            <div key={pillar.title} className="border-t border-[#D4AF37]/40 pt-6" data-reveal style={{ '--reveal-delay': `${index * 90}ms` }}>
              <span className="font-display text-5xl font-medium text-[#D4AF37]">{String(index + 1).padStart(2, '0')}</span>
              <h3 className="mt-4 font-display text-xl font-semibold text-[#F8F6F0]">{pillar.title}</h3>
              <p className="mt-3 font-landing text-[0.92rem] leading-relaxed text-[#CFC8BE]">{pillar.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-24" data-reveal>
          <h3 className="font-display text-2xl font-semibold text-[#F8F6F0]">{section.processTitle}</h3>
          <ol className="mt-10 grid gap-10 md:grid-cols-4 md:gap-6">
            {section.process.map((step, index) => (
              <li key={step.title} className="relative md:pr-6">
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#D4AF37] font-landing text-sm font-semibold text-[#D4AF37]">
                    {index + 1}
                  </span>
                  {index < section.process.length - 1 && <span className="hidden h-px flex-1 bg-gradient-to-r from-[#D4AF37]/60 to-transparent md:block" aria-hidden="true" />}
                </div>
                <h4 className="mt-5 font-landing text-sm font-semibold uppercase tracking-[0.16em] text-[#F8F6F0]">{step.title}</h4>
                <p className="mt-2 font-landing text-[0.9rem] leading-relaxed text-[#CFC8BE]">{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
